import { render, staticRenderFns } from "./reviewDialog.vue?vue&type=template&id=249edd12&scoped=true"
import script from "./reviewDialog.vue?vue&type=script&lang=js"
export * from "./reviewDialog.vue?vue&type=script&lang=js"
import style0 from "./reviewDialog.vue?vue&type=style&index=0&id=249edd12&prod&lang=scss&scoped=true"
import style1 from "./reviewDialog.vue?vue&type=style&index=1&id=249edd12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249edd12",
  null
  
)

export default component.exports